module.exports = __webpack_public_path__ + "img/joinus-bg.ac2ca8b5.png";